import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackEvent } from "../types/facebookPixel";

const RouteChangeTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent("PageView");
  }, [location]);

  return null;
};

export default RouteChangeTracker;